import nodata from "@images/nodata.png";

interface INoDataMessage {
    imagesStyles?: Record<string, string | number>;
    componentStyles?: Record<string, string | number>;
    message: string;
    imageWidth?: string
}

const NoDataMessage: React.FC<INoDataMessage> = ({ imagesStyles, componentStyles, imageWidth, message }) => {
    return (
        <>
            <div
                className="no-data-container"
                style={{
                ...componentStyles
                }}
            >
                <img
                    className="rounded d-bock no-data-image"
                    src={nodata}
                    width={imageWidth || "100px"}
                    alt="No Data"
                    style={{
                        ...imagesStyles
                    }}
                />
                <div className="mt-4 fs-2">{message}</div>
            </div>
        </>
    )
}

export default NoDataMessage